export const version = '12.8.1';
export const buildDate = '2025-07-09T13:22:43.920Z';
export const commitHash = 'ea65cfb';